import React, { memo } from "react";
import ReactHtmlParser from "react-html-parser";
import LazyLoad from "react-lazyload";

const Descripton = memo(({ product_link, description }) => {
  return (
    <div className="sm:mt-5 paddingX-50 ck-content mb-5 overflow-scroll">
      <LazyLoad once={true}>
        <p
          className="bg-white sm:text-xl text-base ck-content"
          dangerouslySetInnerHTML={{ __html: ReactHtmlParser(description) }}
        ></p>
      </LazyLoad>
    </div>
  );
});

export default Descripton;
